<fd-dispatcher fd-dispatcher-action="{
    type: 'APPROVAL.CLEAR'
  }"><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error approving all changes"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="ALL changes have been approved"></wc-toast></then></fd-dispatcher>